import { FC } from "react";
import styles from "./Divider.module.css";

const Divider: FC<{ type: "toolbar" | "dropdown" }> = ({ type }) => <div className={styles[type]} />;

export default Divider;
